"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popup.default;
  }
});

var _Popup = _interopRequireDefault(require("./Popup.react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-popup/dist/index.js
// module id = 552
// module chunks = 0